<template>
  <div>
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h3">인터페이스 정보</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{checkDatetime}}</em></span>
        <el-button size="small" @click="exportNetinterfaceInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
        <w-header-search-button @click="clickShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="interfaceTable" :data="dataList" :columns="interfaceColumns" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;"
    :total="total" :column-default="columnDefault" remote pagination @condition-change="onTableConditionChange">
      <template #oper-status="scope">
        <el-checkbox v-model='scope.row.netinterfaceStatusOper' :true-label= "1" :false-label= "2" disabled></el-checkbox>
      </template>
      <template #admin-status="scope">
        <el-checkbox v-model='scope.row.netinterfaceStatusAdmin' :true-label= "1" :false-label= "2" disabled></el-checkbox>
      </template>
      <template #delete-status="scope">
        <el-checkbox v-model='scope.row.netinterfaceDeleted' :true-label= "1" :false-label= "0" disabled></el-checkbox>
      </template>
      <template #interface-name-slot="scope">
        <span v-if="scope.row.objName" class="link c-pointer" @click="clickInterfaceName(scope.row)">{{scope.row.objName}}</span>
        <span v-else>-</span>
      </template>
    </el-table-wrapper>
  </div>
</template>

<script>
import moment from 'moment';
import { isNil, isEmpty } from 'lodash';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValueForInterfaceSpeed, convertValuByUnit } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

export default {
  name: 'WInterfaceInfoNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      total: null,
      checkDatetime: null,
      showSearchTool: false,
      dataList: null,
      params: {
        netdeviceId: null,
      },
      interfaceColumns: [
        // 2019. 10 .11 인터페이스의 경우 컬럼에 장비 명을 추가해달라는 개선 (SKCC)
        {
          prop: 'parentObjName',
          label: '장비 명',
          remoteProp: 'po.obj_name',
          searchable: true,
        },
        {
          prop: 'netinterfaceStatusOper',
          label: 'Oper 상태',
          scopedSlot: 'oper-status',
          width: 80,
          searchable: false,
        },
        {
          prop: 'netinterfaceStatusAdmin',
          label: 'Admin 상태',
          scopedSlot: 'admin-status',
          width: 90,
          searchable: false,
        },
        {
          prop: 'netinterfaceIfindex',
          label: '인덱스',
          width: 100,
          sortable: true,
          searchable: true,
          remoteProp: 'ni.netinterface_ifindex',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objName',
          label: '인터페이스명',
          sortable: true,
          searchable: true,
          remoteProp: 'o.obj_name',
          scopedSlot: 'interface-name-slot',
        },
        {
          prop: 'netinterfaceDevicename',
          label: '물리명',
          sortable: true,
          searchable: true,
          remoteProp: 'ni.netinterface_devicename',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceAlias',
          label: '인터페이스 별칭',
          sortable: true,
          searchable: true,
          remoteProp: 'ni.netinterface_alias',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceSpeed',
          label: '대역폭',
          searchable: false,
          width: 80,
          remoteProp: 'ni.netinterface_speed',
          formatter: (row, column, value) => convertValueForInterfaceSpeed(value),
        },
        {
          prop: 'netinterfaceDuplex',
          label: 'Duplex',
          sortable: true,
          searchable: true,
          width: 90,
          remoteProp: 'ni.netinterface_duplex',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vlanInterfaceName',
          label: 'VLAN',
          sortable: true,
          searchable: true,
          remoteProp: 'nii.netinterface_devicename',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceMacaddress',
          label: 'MAC 주소',
          sortable: true,
          searchable: true,
          remoteProp: 'ni.netinterface_macaddress',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managegroupName',
          label: '그룹',
          sortable: true,
          searchable: false,
          remoteProp: 'mgrp.managegroup_name',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceDeleted',
          label: '삭제여부',
          width: 80,
          scopedSlot: 'delete-status',
          searchable: false,
        },
      ],
    };
  },
  computed: {
    customerId() {
      return this.$store.state.common.customerId;
    },
  },
  watch: {
    activeTab: {
      handler() {
        this.params.netdeviceId = this.nodeParams.netdeviceId;
        this.loadStore();
      },
    },
    nodeParams: {
      handler() {
        this.params.netdeviceId = this.nodeParams.netdeviceId;
        this.loadStore();
      },
      immediate: true,
    },
  },
  methods: {
    loadStore() {
      if (!isNil(this.params) && this.activeTab === this.$options.name) {
        const tableParams = this.$refs.interfaceTable.getParameter();
        const interfaceParams = {
          netdeviceId: this.params.netdeviceId,
          objId: this.nodeParams.objId,
        };
        const params = Object.assign(tableParams, interfaceParams);
        netdeviceInfoAPI.getNetinterfaceList(params).then((response) => {
          if (response.data.success) {
            this.dataList = response.data.data.data;
            this.total = response.data.total;
            this.checkDatetime = this.checkDatetimeFormatter(response.data.data.checkDatetime);
          }
        });
      }
    },
    exportNetinterfaceInfo() {
      const interfaceParams = {
        netdeviceId: this.params.netdeviceId,
        objId: this.nodeParams.objId,
        customerId: this.customerId,
      };
      const tableParams = this.$refs.interfaceTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        ...tableParams,
        ...interfaceParams,
      };

      netdeviceInfoAPI.exportNetinterfaceInfoList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onTableConditionChange() {
      this.loadStore();
    },
    clickShowSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
    checkDatetimeFormatter(value) {
      return (isNil(value) || value === '-') ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
    /**
     * 인터페이스명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickInterfaceName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/interface/index.vue